import React from 'react'
import LoginForm from './LoginForm'
import Column from '../generic/Column'
import { Link } from 'react-router-dom'

const LoginBox = (props) => {
  return (
    <Column className='is-4 is-offset-4 box app-login-box'>
      <LoginForm />
      <br />
      {/* <div>
        Não possui uma conta? <Link to='/cadastrar-usuario'>Cadastre-se aqui</Link>
      </div> */}
      <div>
        <Link to='/esqueci-minha-senha'>Esqueci minha senha</Link>
      </div>
      <div>
        <Link to='/confirmar-usuario'>Confirmar e-mail</Link>
      </div>
    </Column>
  )
}

export default LoginBox



// WEBPACK FOOTER //
// ./src/components/login/LoginBox.js